import { Component} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { DataService } from 'src/app/_services/data.service';

@Component({
  selector: 'app-offer-list',
  templateUrl: './offer-list.component.html',
  styleUrls: ['./offer-list.component.scss']
})
export class OfferListComponent {
  projUid: string = '';
  compId: string = '';
  // offers: any;
  uniqueSellers: string[] = [];
  uniqueBuildingTitles: string[] = [];
  uniqueNumbers: string[] = [];
  user: any;
  offers: any[] = [];  // Initialize as an empty array

  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    private router: Router, 
    public auth: AuthService
  ) {
    this.projUid = this.route.snapshot.params.idp
    this.compId = this.route.snapshot.params.id;
  }

  ngOnInit(): void {
    this.user = this.auth.currentUserValue;
    if (
      this.user &&
      !this.user.roles.admin &&
      !this.user.roles.GlobalCompEditor &&
      !this.user.roles.editor || !this.user
    ) {
      // Show only offers from the logged-in seller
      return;
    }
    this.dataService.getOffersByProjUid(this.projUid).subscribe(offers => {
      if (Array.isArray(offers)) {
      // if(this.compId === offers.compId){
        // console.log(offers[0]);
        // this.offers = offers;
        if (
          this.user &&
          !this.user.roles.admin &&
          !this.user.roles.GlobalCompEditor &&
          this.user.roles.editor
        ) {
          // Show only offers from the logged-in seller
          this.offers = offers.filter(
            (offer) => offer.seller.email === this.user.email
          );
        } else {
          // Show all offers for admins or global editors
          this.offers = offers;
        }
        this.extractUniqueFilterOptions();
      } else {
        console.error('Offers data is invalid:', offers);
        this.offers = []; // Initialize as empty if data is invalid
      }
      // }
    })
    this.user = this.auth.currentUserValue;
  }

 
  deleteItem(item): void {
    if (confirm('אתה רוצה למחוק הצעה?')) {
      this.dataService.deleteItem(item, 'offers/');
    }
  }

  filters = {
    seller: '',
    buildTitle: '',
    number: ''
  };

  extractUniqueFilterOptions(): void {
    this.uniqueSellers = Array.from(
      new Set(this.offers.map((offer) => offer.seller.name))
    );
    this.uniqueBuildingTitles = Array.from(
      new Set(
        this.offers
          .flatMap((offer) => offer.appartmentsIdArray)
          .map((apartment) => apartment.buildTitle)
      )
    );
    this.uniqueNumbers = Array.from(
      new Set(
        this.offers
          .flatMap((offer) => offer.appartmentsIdArray)
          .map((apartment) => apartment.number)
      )
    );
  }

  filteredOffers() {
    if (!this.offers || !Array.isArray(this.offers)) {
      return []; // Return an empty array if `this.offers` is not ready
    }
  
    return this.offers.filter((offer) => {
      const matchesSeller =
        !this.filters.seller || offer.seller.name === this.filters.seller;
  
      const matchesBuildTitle =
        !this.filters.buildTitle ||
        offer.appartmentsIdArray.some(
          (apartment) => apartment.buildTitle === this.filters.buildTitle
        );
  
      const matchesNumber =
        !this.filters.number ||
        offer.appartmentsIdArray.some(
          (apartment) => apartment.number === this.filters.number
        );
  
      return matchesSeller && matchesBuildTitle && matchesNumber;
    });
  }
  

  deleteOffer(offerToDelete: any): void {
    this.offers = this.offers.filter((offer) => offer !== offerToDelete);
    this.extractUniqueFilterOptions(); // Rebuild filter options after deletion
  }
}